export default {
    "首页":"Home",
    "发展历史":"History",
    "资质荣誉":"Qualifications & Honors",
    "宣传视频":"Promotional Videos",
    "新闻资讯":"News & Information",
    "产品展示":"Products",
    "客户案例":"Case Studies",
    "下载中心":"Download Center",
    "联系我们":"Contact Us",
    "公司":"Company",
    "联系人":"Contact Person",
    "传真":"Fax",
    "邮件":"Email",
    "邮政编码":"Postal Code",
    "网址":"Website",
    "地址":"Address",
    "在线留言":"Online Message",
    "标题":"Title",
    "请填写标题":"Please enter the title",
    "姓名":"Name",
    "请填写姓名":"Please enter your name",
    "电话":"Phone",
    "请填写电话":"Please enter your phone number",
    "内容":"Content",
    "请填写内容":"Please enter the content",
    "提交消息":"Submit Message",
    "邮箱":"Email",
    "来源":"Source",
    "创建时间":"Creation Time",
    "点击量":"Click Count",
    "属于":"Belongs To",
    "上一条":"Previous",
    "下一条":"Next",
    "产品ID":"Product ID",
    "购买价格":"Purchase Price",
    "发布时间":"Release Time",
    "下载":"Download",
    "暂无下一条数据":"No more data",
    "暂无上一条数据":"No previous data",
    "登录":"Login",
}